import { Head, router } from '@inertiajs/react'
import { Badge, Box, Button, Card, DataList, Flex, Heading, Link, Separator, Text } from '@radix-ui/themes'
import { badgeColors } from '@/shared/constants/constants'
import { CredentialsApproveProps } from '@/types/credentials_approve'

export default function CredentialsApprove({
  status,
  category,
  email,
  form_title,
  track_name,
  submitted_at,
  expires_at,
  fields,
  approve_path,
  review_path,
}: CredentialsApproveProps) {
  return (
    <>
      <Head title="Approve credential" />
      <Box style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
        <Heading size="7">Annual credential</Heading>
        <Text size="3" color="gray" as="p">
          {form_title} at {track_name}
        </Text>
        <Separator my="4" size="4" />

        <Card>
          <Flex justify="between" align="start" gap="4" mb="3">
            <Flex direction="column" gap="1">
              <Heading size="5">{email}</Heading>
              <Text size="3" color="gray">
                {submitted_at && `Submitted ${submitted_at}`}
                {expires_at && ` · Expires ${expires_at}`}
              </Text>
            </Flex>
            <Flex direction="column" gap="2" align="end">
              <Badge color={badgeColors[status]} size="2">
                {status}
              </Badge>
              <Badge color="gray" size="2" style={{ textTransform: 'capitalize' }}>
                {category}
              </Badge>
            </Flex>
          </Flex>

          <Separator size="4" mb="3" />

          {/* Same DataList as applications/approve, but stacked: a credential's
              labels are whole questions, so a label column would swallow the width. */}
          <DataList.Root orientation="vertical">
            {fields.map((field) => (
              <DataList.Item key={field.key}>
                <DataList.Label>{field.label}</DataList.Label>
                <DataList.Value>{field.value}</DataList.Value>
              </DataList.Item>
            ))}
          </DataList.Root>
          {fields.length === 0 && <Text color="gray">No answers submitted.</Text>}
        </Card>

        <Flex direction="column" gap="3" mt="4">
          {status === 'pending' ? (
            <Button size="3" onClick={() => router.post(approve_path)}>
              Approve credential
            </Button>
          ) : (
            <Text color="gray">
              This credential is already <strong>{status}</strong> — no further action needed here.
            </Text>
          )}
          <Text size="2" color="gray">
            Need to reject it, or leave a note?{' '}
            <Link href={review_path} underline="always">
              Open it in your dashboard
            </Link>{' '}
            (login required).
          </Text>
        </Flex>
      </Box>
    </>
  )
}
